import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "style", "id", "icon", "onClose", "color", "closable", "size", "disabled", "label", "children", "title"];
import * as React from 'react';
import classNames from 'classnames';
import { KEY_VALUES, setupGetInstanceId } from '../utils';
var getInstanceId = setupGetInstanceId();
var Tag = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames;
  var customizePrefixCls = _ref.prefixCls,
    className = _ref.className,
    style = _ref.style,
    id = _ref.id,
    icon = _ref.icon,
    onClose = _ref.onClose,
    color = _ref.color,
    _ref$closable = _ref.closable,
    closable = _ref$closable === void 0 ? true : _ref$closable,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    label = _ref.label,
    children = _ref.children,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'clear tag' : _ref$title,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var prefixCls = customizePrefixCls ? customizePrefixCls + "-tag" : 'ap-tag';
  var tagId = id || "tag-" + getInstanceId();
  var tagClassName = classNames(prefixCls, 'ap-tag-default', className, (_classNames = {}, _classNames[prefixCls + "-" + size] = size, _classNames[prefixCls + "-disabled"] = disabled, _classNames));
  var tagStyle = _extends({
    backgroundColor: color ? color : undefined
  }, style);
  var handleCloseClick = function handleCloseClick(event) {
    if (onClose) {
      onClose(event);
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    var key = event.key;
    if (KEY_VALUES.SPACE === key || KEY_VALUES.ENTER === key) {
      event.preventDefault();
      if (onClose) {
        onClose(event);
      }
    }
  };
  var renderCloseIcon = function renderCloseIcon() {
    if (closable) {
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "Appkit4-icon icon-close-outline",
        title: title,
        disabled: disabled,
        "aria-disabled": disabled,
        "aria-labelledby": tagId,
        onClick: handleCloseClick,
        onKeyDown: handleKeyDown
      });
    }
    return null;
  };
  var ariaLabel = label;
  if (!ariaLabel) {
    typeof children === 'string' ? ariaLabel = children : ariaLabel = children === null || children === void 0 ? void 0 : children.toString();
  }
  var tagNode = /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: tagClassName,
    id: tagId,
    style: tagStyle,
    "aria-label": ariaLabel
  }, props), icon, /*#__PURE__*/React.createElement("span", {
    className: prefixCls + "-label",
    title: ariaLabel
  }, label || children), renderCloseIcon());
  return tagNode;
});
Tag.displayName = 'Tag';
export default Tag;